import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles((theme: Theme) => ({
  paper: {
    fontFamily: `'Manrope', sans-serif`,
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    width: "32vw",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: 8,
    // padding: "1.5rem",
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  modalBody: {
    height: "100%",
    width: "100%",
    position: "relative",
    "@media (min-height: 750px)": {
      overflowX: "hidden",
    },
    [theme.breakpoints.down("md")]: {
      overflowY: "scroll",
      overflowX: "hidden",
    },
    [theme.breakpoints.down("sm")]: {
      height: "70vh",
      overflowY: "scroll",
      overflowX: "hidden",
      paddingRight: ".55rem",
    },
    "& button": {
      fontFamily: `'Manrope', sans-serif`,
    },
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    padding: "1.5rem",
    paddingBottom: 0,
  },
  modalHeaderTitle: {
    marginBottom: 8,
    fontSize: 20,
    lineHeight: "28px",
    color: "#232325",
    fontWeight: 800,
    marginLeft: 13,
  },
  modalHeaderSubtitle: {
    fontSize: 14,
    lineHeight: "24px",
    color: "#6F727A",
    fontWeight: "normal",
  },
  modalSection: {
    padding: "1.5rem",
    paddingTop: 0,
  },
  modalFooter: {
    background: "#F7F7F9",
    height: 80,
    padding: "16px 1.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    borderRadius: "0 0 8px 8px",
  },
  modalFooterCancel: {
    background: "transparent",
    color: "#F97066",
    borderRadius: 8,
    boxShadow: "none",
    marginRight: 8,
    "&:hover": {
      background: "transparent",
      color: "#F97066",
    },
  },
  modalFooterAssign: {
    background: "#32D583",
    color: "#fff",
    borderRadius: 8,
    boxShadow: "none",
    "&:hover": {
      background: "#32D583",
      color: "#fff",
    },
  },
  warningIcon: {
    color: "#F04438",
    backgroundColor: "#FECDCA",
    fontSize: 20,
    padding: 11,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    color: "#232325",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px",
  },
  warningText: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: "24px",
    color: "#F04438",
    fontStyle: "italic",
  },
}));

export default styles;
